module.exports = "<div [ngClass]=\"title.class\">\n  <p class=\"label\">{{ title.label }}</p>\n  <p class=\"count mat-headline\">{{ title.count }}</p>\n</div>"